import * as React from "react";
import { IsLoggedIn, Selectors } from "@grandvisionhq/auth";
import { useIntl, useSelector } from "@grandvisionhq/state";
import PreferredStoreButton from "./PreferredStoreButton.js";
/* empty css                          */
import usePreferredStore from "../../../../hooks/hooks/use-preferred-store.js";
import useUpdatePreferredStore from "../../../../hooks/api/hooks/api/use-update-preferred-store.js";
import useGetPreferredStoreId from "../../../../hooks/api/hooks/api/use-get-preferred-store-id.js";
const PreferredStoreButtonContainer = ({ storeId, storeName }) => {
  const { getLabel } = useIntl();
  const userId = useSelector(Selectors.getUserId);
  const isLoggedIn = useSelector(Selectors.isLoggedIn);
  const { onHandlePreferredStoreChange } = usePreferredStore(storeName);
  const {
    updatePersonalDetails,
    data: mutatedData,
    loading: isUpdating
  } = useUpdatePreferredStore({
    onCompleted: () => onHandlePreferredStoreChange(
      isUpdating,
      true,
      "stores.storeDetailsRoot.preferredStoreUpdate.success"
    ),
    onError: (_, label) => {
      onHandlePreferredStoreChange(isUpdating, false, label);
    }
  });
  const { data, loading } = useGetPreferredStoreId();
  if (loading || !userId || !isLoggedIn) {
    return null;
  }
  const { globalStoreId: preferredStoreId } = data ?? {};
  const isPreferredStore = storeId === preferredStoreId || storeId === mutatedData?.globalStoreId;
  const onClick = () => updatePersonalDetails(storeId, userId);
  return /* @__PURE__ */ React.createElement(
    PreferredStoreButton,
    {
      labels: {
        preferredStore: getLabel("stores.preferredStoreButton.active"),
        setPreferredStore: getLabel("stores.preferredStoreButton.set")
      },
      onClick,
      selected: isPreferredStore
    }
  );
};
const PreferredStoreButtonContainer$1 = (props) => /* @__PURE__ */ React.createElement(IsLoggedIn, null, /* @__PURE__ */ React.createElement(PreferredStoreButtonContainer, { ...props }));
export {
  PreferredStoreButtonContainer$1 as default
};
//# sourceMappingURL=PreferredStoreButtonContainer.js.map
